import { Row, Col, Form, Button } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const WebContentMetrics = ({ data, setData }) => {
	const handleAddDetail = () => {
		let newDetail = [...data.details];
		newDetail.push({
			id: "",
			pretitle: "",
			title: "",
			postTitle: "",
			description: "",
		});

		setData({ ...data, details: newDetail });
	};

	const removeDetail = (j) => {
		let newDetail = [...data.details];
		newDetail.splice(j, 1);

		setData({ ...data, details: newDetail });
	};

	return (
		<Row className={classes.row_form}>
			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Antetítulo</Form.Label>
					<Form.Control
						value={data && data.pretitle}
						onChange={(e) =>
							setData({
								...data,
								pretitle: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Título</Form.Label>
					<Form.Control
						value={data && data.title}
						onChange={(e) =>
							setData({
								...data,
								title: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<span style={{ fontWeight: "500", color: "#7fb02f" }}>Detalle</span>
				{data &&
					data.details &&
					data.details.map((detail, j) => {
						return (
							<Row className={classes.web_div_detail} key={j}>
								<Col md={11} xs={11}>
									<Form.Group className={classes.group_form}>
										<Form.Label className={classes.label}>Antetítulo</Form.Label>
										<Form.Control
											value={detail && detail.pretitle}
											onChange={(e) => {
												let newDetails = [...data.details];
												newDetails[j].pretitle = e.currentTarget.value;

												setData({
													...data,
													details: newDetails,
												});
											}}
											type="text"
										/>
									</Form.Group>
								</Col>
								<Col md={1} xs={1}></Col>
								<Col md={11} xs={11}>
									<Form.Group className={classes.group_form}>
										<Form.Label className={classes.label}>Título</Form.Label>
										<Form.Control
											value={detail && detail.title}
											onChange={(e) => {
												let newDetails = [...data.details];
												newDetails[j].title = e.currentTarget.value;

												setData({
													...data,
													details: newDetails,
												});
											}}
											type="text"
										/>
									</Form.Group>
								</Col>
								<Col md={1} xs={1}>
									<RemoveSvg
										onClick={() => removeDetail(j)}
										style={{
											cursor: "pointer",
											height: "2em",
											width: "2em",
										}}
									/>
								</Col>
								<Col md={11} xs={11}>
									<Form.Group className={classes.group_form}>
										<Form.Label className={classes.label}>Postítulo</Form.Label>
										<Form.Control
											value={detail && detail.postTitle ? detail.postTitle : ""}
											onChange={(e) => {
												let newDetails = [...data.details];
												newDetails[j].postTitle = e.currentTarget.value;

												setData({
													...data,
													details: newDetails,
												});
											}}
											type="text"
										/>
									</Form.Group>
								</Col>
								<Col md={1} xs={1}></Col>

								<Col md={11} xs={11}>
									<Form.Group className={classes.group_form}>
										<Form.Label className={classes.label}>Descripción</Form.Label>
										<Form.Control
											value={detail && detail.description}
											onChange={(e) => {
												let newDetails = [...data.details];
												newDetails[j].description = e.currentTarget.value;

												setData({
													...data,
													details: newDetails,
												});
											}}
											as="textarea"
											rows={4}
										/>
									</Form.Group>
								</Col>
								<Col md={1} xs={1}></Col>
							</Row>
						);
					})}
			</Col>

			<Col md={12} xs={12}>
				<Button onClick={() => handleAddDetail()}>Agregar Detalle</Button>
			</Col>
		</Row>
	);
};

export default WebContentMetrics;
